import React, { useRef } from 'react';

import SearchInputComponent from '@components/common/searchInput';
import ColorWrapper from '@styles/colors';
import { ColorFunction } from '@styles/colors/types';
import { TextInput, View } from 'react-native';
import { font } from '@styles/fonts';
import { ScaleFunction } from '@components/operatorPanel/interfaces';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '@store/hooks/useAppDispatch';
import { selectPlanboardSearchValue, setPlanboardSearchValue } from '@reducers/v2/planboard';

interface SearchInputProps {
  C: ColorFunction;
  scale: ScaleFunction;
  font: typeof font;
}

const SearchInput: React.FC<SearchInputProps> = ({ C, font, scale }) => {
  const dispatch = useAppDispatch();
  const searchRef = useRef<TextInput>(null);

  const searhcValue = useSelector(selectPlanboardSearchValue);

  return (
    <View
      style={{
        width: scale(271),
      }}
    >
      <SearchInputComponent
        C={C}
        searchRef={searchRef}
        cancelAnimation={() => dispatch(setPlanboardSearchValue(''))}
        onBlur={console.log}
        onFocus={console.log}
        onSearch={(value) => dispatch(setPlanboardSearchValue(value))}
        searchValue={searhcValue ?? ''}
        scale={scale}
        font={font}
      />
    </View>
  );
};

export default ColorWrapper(SearchInput);
